import classnames from 'classnames';
import '../styles/Divider.scss';

interface DividerProps {
    className?: string;
}

export function Divider({ className } : DividerProps) { return <div className={classnames('palette-divider', className)} />; }
